<template>

  <v-container class="px-4 px-sm-0">
    <v-container class="bg-white rounded-lg">

      <v-container class="mb-8 py-0">
        <v-tabs
          v-model="localita"
          class="border-b-sm"
          color="indigo-darken-1"
          @update:model-value="(value) => tabChange(value)"
        >
          <v-tab v-for="(localita) in localitaTabs" :value="localita.id">{{ localita.name }}</v-tab>
        </v-tabs>
      </v-container>

      <loader v-if="loading === true" />
      <v-container v-for="(item) in previsioni" class="overflow-x-auto">
        <previsione-table v-if="loading !== true" :localita="selectedLocalita" :previsione="item" />
      </v-container>

    </v-container>
  </v-container>

</template>


<script lang="ts">
import { PrevisioneGiorno } from '@/modules/api';
import { LocalitaTab } from '@/modules/localitaTab';
import { defineComponent } from 'vue';
import PrevisioneTable from '@/components/home/PrevisioneTable.vue';
import Loader from '@/components/Loader.vue';

export default defineComponent({
  name: "PrevisioneComponent",
  props: {
    "previsioni": {
      type: Object as () => PrevisioneGiorno[]
    },
    "localitaTabs": { 
      type: Object as () => LocalitaTab[]
    },
    "loading": {
      type: Boolean
    }
  },
  components: {
    PrevisioneTable,
    Loader
  },
  data(): PrevisioneDataInterface {
    return {
      localita: undefined,
      selectedLocalita: undefined
    }
  },
  methods: {
    tabChange(id: any) {
      this.selectedLocalita = this.localitaTabs?.find((value) => value.id == id)
      this.$emit('localitaChanged', { localitaId: id });
    }
  },
})

interface PrevisioneDataInterface {
  localitaTabs?: LocalitaTab[],
  localita?: number,
  selectedLocalita?: LocalitaTab,
}

</script>